import { ServicingParams, ServicingTypes } from 'app/models/servicing-params'

/** Where a Servicing row opens on click, from the facts the feed row carries; undefined when it opens nowhere. */
export const servicingRowTarget = (
  row: ServicingParams,
): string | undefined => {
  switch (row.type) {
    // the loan-rooted rows open their facility's loans tab; the feed names the
    // facility and its state, so no loan or facility list is needed
    case ServicingTypes.principalPayment:
    case ServicingTypes.loanRollover:
    case ServicingTypes.loanRolloverSplit:
    case ServicingTypes.loanRateSetting:
    case ServicingTypes.loanConversion:
    case ServicingTypes.loanIncrease:
    case ServicingTypes.loanAddRates:
    case ServicingTypes.pik:
    case ServicingTypes.maturingLoan:
    case ServicingTypes.pikScheduleLoan:
    case ServicingTypes.newBorrowing:
      return row.facilityId && row.facilityStatus
        ? `/dealmanagement/facilities/${row.facilityId}/${row.facilityStatus}/loans`
        : undefined
    case ServicingTypes.amortizationSchedule:
      return `/dealmanagement/facilities/${row.id}/${row.original?.status ?? 'Approved'}/amortization-schedule`
    case ServicingTypes.maturingFacility:
      return `/dealmanagement/facilities/${row.id}/${row.original?.status ?? 'Approved'}`
    case ServicingTypes.maturingDeal:
      return `/dealmanagement/deal/${row.id}/${row.original?.status ?? 'Approved'}`
    default:
      return undefined
  }
}

export const handleServicingRowClicked = (
  row: ServicingParams,
  navigate: (to: string) => void,
) => {
  const target = servicingRowTarget(row)
  if (target) navigate(target)
}
